import { createSelector } from 'reselect';
import { getEaTravelRates } from './index';
import { API_CALL_STATUS } from '../../reducers/status';

export const getAuthDetails = createSelector(getEaTravelRates, (travelInsurance) => travelInsurance?.auth);

export const getAccessToken = createSelector(getAuthDetails, (auth) => auth?.loginData);

export const getAuthVerifyData = createSelector(getAuthDetails, (auth) => auth?.verifyData);

export const getVerifyApiCallStatus = createSelector(getAuthDetails, (auth) => auth?.verifyApiCallStatus);

export const getIsApiPending = createSelector(
    getAuthDetails,
    (auth) =>
        auth.authLoginApiCallStatus === API_CALL_STATUS.PENDING ||
        auth.loginApiCallStatus === API_CALL_STATUS.PENDING ||
        auth.verifyApiCallStatus === API_CALL_STATUS.PENDING
);

export const getAuthLoginApiCallStatus = createSelector(getAuthDetails, (auth) => auth?.authLoginApiCallStatus);

export const getAuthForm = createSelector(getAuthDetails, (authDetails) => authDetails.form);

const makeGetFormField = (fieldId) => createSelector(getAuthForm, (form) => form[fieldId]);

export const getEmailValue = makeGetFormField('email');
export const getOtpValue = makeGetFormField('otp');
export const getShowOtpScreen = makeGetFormField('showOtpScreen');
